import React, { useEffect, useState } from "react";
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ConvoAskForm = (params) => {
  const { onSubmit, phases = [] } = params;
  // A script is "phased" iff it has >1 distinct phase (mirrors the matcher gate).
  // For a phased script the backend requires a phase and 400s without one, so we
  // make it a required selector; unphased scripts hide it entirely.
  const phased = phases.length > 1;
  const [question, setQuestion] = useState("");
  const [phase, setPhase] = useState("");

  // Phases arrive after the first render. Selecting the first one as soon as
  // they land means a phased script is askable straight away instead of the
  // author having to pick before the form does anything; they can still change
  // it, and an explicit choice is never overwritten.
  useEffect(() => {
    if (phased) setPhase((current) => current || phases[0]);
  }, [phased, phases]);

  const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (phased && !phase) return; // guard: phase is required for phased scripts
    onSubmit(question, phased ? phase : undefined);
    setQuestion("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack direction="row" spacing={2} alignItems="center">
        {phased && (
          <FormControl sx={{ minWidth: 200 }} required>
            <InputLabel id="phase-label">Phase</InputLabel>
            <Select
              labelId="phase-label"
              id="phase"
              name="phase"
              value={phase}
              label="Phase"
              onChange={(event) => setPhase(event.target.value)}
            >
              {phases.map((p) => (
                <MenuItem key={p} value={p}>
                  {p}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField
          sx={{ flexGrow: 1 }}
          id="question"
          type="text"
          name="question"
          // Land on the page and type: with the phase preselected above, the
          // caret here is the whole interaction. jsx-a11y/no-autofocus guards
          // against stealing focus on general pages; this route exists only to
          // ask a question, and the field is its primary control, so the focus
          // is expected rather than a surprise.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          // Enter sends. Implicit form submission does not fire here (the phase
          // Select contributes a second input), so ask for it explicitly rather
          // than making every question end in a click.
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) handleSubmit(event);
          }}
          label="Ask a question"
          value={question}
          onChange={handleQuestionChange}
          variant="outlined"
        />
        <Button variant="contained" startIcon={<SendIcon />} color="success" type="submit" disabled={phased && !phase}>
          Send
        </Button>
      </Stack>
    </form>
  );
};

export default ConvoAskForm;
